module.exports = __webpack_public_path__ + "img/logo.e1bbc187.png";